import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

// 1 publish
const publish_question_request = () => {
  return {
    type: questionsTypes.publish.request
  }
}

const publish_question_success = (response) => {
  return {
    type: questionsTypes.publish.success,
    payload: response.data
  }
}

const publish_single_question_success = (response) => {
  return {
    type: questionsTypes.publish.single,
    payload: response.data
  }
}

const publish_question_failure = (messages) => {
  return {
    type: questionsTypes.publish.failure,
    payload: messages
  }
}

const publish_question = (question_id, index=true, page=1, per_page=10, filters={}, sort="", order="") => {
  return function(dispatch) {
    // Before Request
    dispatch( publish_question_request() )
    const reqParams = index ? {
      index: index,
      page: page,
      per_page: per_page,
      sort: sort,
      order: order,
      filters: filters
    } : {index: index}
    // Request
    axios.post(
      formatRoute(QUESTIONS_ROUTES.publish, {id: question_id}),
      reqParams
    ).then( response => {
      window.showSnackbar('success', 'The question status has changed to: Published.')
      if ( index ) {
        dispatch( publish_question_success(response) )

      } else {
        dispatch( publish_single_question_success(response) )

      }
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error publishing question"]
      }
      dispatch( publish_question_failure( errors ) )
    })
  }
}

export {publish_question}



// WEBPACK FOOTER //
// ./src/js/actions/questions/publish.js